export class FlowModuleEvents {
    public static readonly ENTER_BASIC_STATE: symbol = Symbol('ENTER_BASIC_STATE');
    public static readonly WON_BIG_WIN: symbol = Symbol('WON_BIG_WIN');
    public static readonly WON: symbol = Symbol('WON');
    public static readonly NO_WIN: symbol = Symbol('NO_WIN');
    public static readonly BONUS_GAME_WON: symbol = Symbol('BONUS_GAME_WON');
    public static readonly FREESPINS_WIN: symbol = Symbol('FREESPINS_WIN');
    public static readonly FREESPINS_RETRIGGER_WIN: symbol = Symbol('FREESPINS_RETRIGGER_WIN');
    public static readonly FREE_SPINS_FINISHED: symbol = Symbol('FREE_SPINS_FINISHED');
    public static readonly RESPIN_WIN: symbol = Symbol('RESPIN_WIN');
    public static readonly HAS_RESPIN_ON_NEXT_SPIN: symbol = Symbol('HAS_RESPIN_ON_NEXT_SPIN');
    public static readonly NO_RESPIN_ON_NEXT_SPIN: symbol = Symbol('NO_RESPIN_ON_NEXT_SPIN');

    public static readonly FREESPINS_RESTORED: symbol = Symbol('FREESPINS_RESTORED');
    public static readonly RESPIN_ON_FREESPINS_RESTORED: symbol = Symbol('RESPIN_ON_FREESPINS_RESTORED');
    public static readonly RESTORE_RESPIN_WINNING_REELSET: symbol = Symbol('RESTORE_RESPIN_WINNING_REELSET');
    public static readonly RESPIN_RESTORED: symbol = Symbol('RESPIN_RESTORED');

    public static readonly SELECT_BONUS_START: symbol = Symbol('SELECT_GAME_START');
    public static readonly SELECT_BONUS_RESTORED: symbol = Symbol('SELECT_BONUS_RESTORED');

    public static readonly WP_RESTORE: symbol = Symbol('WP_RESTORE');
    public static readonly BET_RESTORE: symbol = Symbol('BET_RESTORE');

    public static readonly SHOULD_START_INDIVIDUAL_WIN_FREESPINS =
        Symbol('SHOULD_START_INDIVIDUAL_WIN_FREESPINS');
    public static readonly SHOULD_START_INDIVIDUAL_WIN_AFTER_POPUP_FREESPINS =
        Symbol('SHOULD_START_INDIVIDUAL_WIN_AFTER_POPUP_FREESPINS');

    public static readonly BIG_WIN_AFTER_FREE_SPINS_STARTED: symbol = Symbol('BIG_WIN_AFTER_FREE_SPINS_STARTED');
    public static readonly BIG_WIN_AFTER_BONUS_GAME_STARTED: symbol = Symbol('BIG_WIN_AFTER_BONUS_GAME_STARTED');
    public static readonly BIG_WIN_AFTER_RETRIGGER_STARTED: symbol = Symbol('BIG_WIN_AFTER_RETRIGGER_STARTED');

    public static readonly CAN_SPIN: symbol = Symbol('CAN_SPIN');

    public static readonly BLOCKING_FLOW: symbol = Symbol('BLOCKING_FLOW');
    public static readonly NON_BLOCKING_FLOW: symbol = Symbol('NON_BLOCKING_FLOW');

    public static readonly ROUND_ENDED: symbol = Symbol('ROUND_ENDED');

    public static readonly START_PICK_BONUS: symbol = Symbol('START_PICK_BONUS');
    public static readonly RESTORE_PICK_BONUS: symbol = Symbol('RESTORE_PICK_BONUS');
    public static readonly START_PICK_BONUS_AWARD: symbol = Symbol('START_PICK_BONUS_AWARD');
    public static readonly SKIP_PICK_BONUS_AWARD: symbol = Symbol('SKIP_PICK_BONUS_AWARD');
    public static readonly PICK_GAME_RESTORED: symbol = Symbol('PICK_GAME_RESTORED');

    public static readonly START_COIN_FLIGHT_FEATURE: symbol = Symbol('START_COIN_FLIGHT_FEATURE');

    public static readonly FEATURE_STARTED: symbol = Symbol('FEATURE_STARTED');
    public static readonly FEATURE_FINISHED: symbol = Symbol('FEATURE_FINISHED');

    public static readonly START_COLLAPSING: symbol = Symbol('START_COLLAPSING');
    public static readonly FINISH_PICK_BONUS: symbol = Symbol('FINISH_PICK_BONUS');
}
